module.exports = __webpack_public_path__ + "img/circle.8bd023db.png";